export default __webpack_public_path__ + "static/media/b2b-works-1.25cc10d5.svg";